<template>
  <v-container>

    <!-- Date Filter -->
    <v-card class="pa-4 mb-6" elevation="0" outlined>
      <v-row align="center">
        <v-col cols="12">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedDateRange"
                label="篩選時間"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateRange"
              :selected-items-text="formattedDateRange"
              range
              type="month"
              locale="zh-TW"
              :allowed-dates="allowedMonths"
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-card>

    <template v-if="mode === 'route'">
      <v-tabs :value="$route.name" class="mb-6">
        <v-tab :to="{ name: 'analyticsOnlineReserveSummary' }" value="analyticsOnlineReserveSummary">線上約診成效-總覽</v-tab>
        <v-tab :to="{ name: 'analyticsOnlineReserveDetail' }" value="analyticsOnlineReserveDetail">線上約診成效-進階</v-tab>
      </v-tabs>

      <router-view :date-range="dateRange"></router-view>
    </template>

    <template v-if="mode === 'inline-tab'">
      <v-tabs v-model="tab" class="mb-6">
        <v-tab>線上約診成效-總覽</v-tab>
        <v-tab>線上約診成效-進階</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <OnlineSummaryAnalysisTab :date-range="dateRange"/>
        </v-tab-item>
        <v-tab-item>
          <OnlineDetailAnalysisTab :date-range="dateRange"/>
        </v-tab-item>
      </v-tabs-items>
    </template>

  </v-container>
</template>

<script>
import dayjs from "dayjs";
import OnlineSummaryAnalysisTab from "@/components/analytics/OnlineSummaryAnalysisTab.vue";
import OnlineDetailAnalysisTab from "@/components/analytics/OnlineDetailAnalysisTab.vue";

export default {
  name: 'OnlineReserveAnalysisV2',
  components: {OnlineDetailAnalysisTab, OnlineSummaryAnalysisTab},
  props:{
    mode: {
      type: String,
      default: 'route'
    }
  },
  data() {
    const currentMonth = dayjs().format('YYYY-MM');
    const threeMonthsAgo = dayjs().subtract(2, 'month').format('YYYY-MM');

    return {
      dateMenu: false,
      dateRange: [threeMonthsAgo, currentMonth],

      tab: null
    }
  },
  computed: {
    formattedDateRange() {
      if (!this.dateRange || this.dateRange.length !== 2) return '';
      const [start, end] = [...this.dateRange].sort();
      return `${start} ~ ${end}`;
    },
  },
  methods: {
    allowedMonths(v) {
      return dayjs(v) < dayjs().endOf('month') && dayjs(v) > dayjs().subtract(24, 'month');
    },
  }
};
</script>